import React, { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';

const ExhibitionistConfigPopover = lazy(
  () => import(/* webpackChunkName: "owner" */ '..')
);

type Props = any;

const ExhibitionistConfigPopoverLazy: React.FC<Props> = props => {
  return (
    <Suspense fallback={<WidgetConfigPopover isLoading onClose={() => null} />}>
      <ExhibitionistConfigPopover {...props} />
    </Suspense>
  );
};
ExhibitionistConfigPopoverLazy.displayName = 'ExhibitionistConfigPopoverLazy';

export default ExhibitionistConfigPopoverLazy;
